import { render, staticRenderFns } from "./ShippingAddressForm.vue?vue&type=template&id=718e73ab&scoped=true&"
import script from "./ShippingAddressForm.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e73ab",
  null
  
)

export default component.exports